import { styled } from '@mui/material';
import { MapDetail } from '@procureai/ui-mui';

export const MapDetailStyled = styled(MapDetail)(({ theme }) => ({
  position: 'absolute',
  width: 340,
  top: 0,
  right: 0,
  bottom: 0,
  margin: theme.spacing(3),
}));
